<template>
  <div class="TokCategoryCarousel" :class="{ hasDots: !md.mobile() }">
    <div class="TokCategoryCarousel__head">
      <div class="TokCategoryCarousel__head__title">{{ $t('OTHER_VIDEOS') }}</div>
    </div>
    <div class="TokCategoryCarousel__body">
      <flickity
        ref="flickity"
        :options="flickityOptions"
        @disablePlay="disablePlay"
        @enablePlay="enablePlay"
      >
        <div
          :class="`carousel-cell xs-slide-3 ${mobile}`"
          v-for="category in categories"
          :key="category.title"
          :id="category.category_id"
        >
          <div class="slide__inner" :style="'cursor: pointer;'" @click="navigate(category)">
            <bkg :url="category.cover"/>
            <div class="slide__inner__shadow">
            </div>
            <div class="slide__inner__btnTitle">
              {{ category.title }}
            </div>
          </div>
        </div>
      </flickity>
    </div>
  </div>
</template>
<script>
import slugify from 'slugify';
import replace from 'lodash.replace';
import { mapState } from 'vuex';
import bkg from './Bkg.vue';
import Flickity from './flickity.vue';

export default {
  name: 'Categories',
  props: ['categories', 'aspectRatio'],
  components: {
    bkg,
    Flickity,
  },
  data() {
    return {
      canPlay: true,
    };
  },
  methods: {
    play(obj) {
      if (this.canPlay) this.playVideoById(obj);
    },
    disablePlay() {
      this.canPlay = false;
    },
    enablePlay() {
      this.canPlay = true;
    },
    scaleImage(url) {
      return replace(url, '{$width}', '1080');
    },
    navigate(category) {
      if (!this.canPlay) return;
      window.ga('tok.send', 'event', 'Main Categories', 'Launch Category', category.category_id);
      this.$store.dispatch('loadCategory', category)
        .then(() => {
          this.$router.push(slugify(category.title));
        });
    },
  },
  computed: {
    ...mapState(['colors', 'md']),
    flickityOptions() {
      return {
        cellAlign: 'left',
        initialIndex: 0,
        prevNextButtons: (!this.md.mobile() && this.categories.length > 3),
        pageDots: false,
        groupCells: false,
        freeScroll: true,
        contain: true,
        wrapAround: this.categories.length > 3,
      };
    },
    mobile() {
      return this.md.mobile() ? 'mobile' : '';
    },
  },
};
</script>
